import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'sex_gender_2'

export const dataPointDefinition = {
  retracedId: 'sex_gender_2',
  name: 'Sex / Gender',
  description:
    'This item also includes distinctions based on marital status or family responsibilities, if those distinctions are applied to one sex, or have a disproportionate impact on one sex. Workers with family responsibilities refers to men and women with responsibilities in relation to their dependent child',
  meta: {
    slcpMeta: {
      key: 'disc-7--2',
      number: 'WT-DIS-10-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'disc-7--2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26810,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
